import * as React from 'react'

import { withFormik } from 'formik'

import { Experience }                            from '../../api'
import loadable                                  from '../hocs/loadable'
import { InjectedStepperProps }                  from '../organisms'
import { EducationChunk }                        from './chunks'
import { genValueMapper, proxyFormikSubmission } from './form-utils'
import { educationSchema, emptyEducation }       from './schemas'
import { EducationFields }                       from './types'
import { asFormStep, SimpleSubmitFormWrapper }   from './wrappers'

const formikConfig = {
  validationSchema: educationSchema,
  mapPropsToValues: genValueMapper(emptyEducation),
  handleSubmit:     proxyFormikSubmission,
}

export const EducationFormStep = withFormik<InjectedStepperProps, EducationFields>(
  formikConfig,
)(asFormStep(EducationChunk))

export default loadable(
  withFormik<any, { experience: Experience [] }>(formikConfig)(
    props => (
      <SimpleSubmitFormWrapper {...props}>
        {(inner: any) => <EducationChunk {...inner} />}
      </SimpleSubmitFormWrapper>
    ),
  ),
)



// WEBPACK FOOTER //
// ./src/components/forms/EducationEditForm.tsx